import {
  PREQUAL_QUESTION_ANSWERED,
  PREQUAL_QUESTION_NOT_ANSWERED,
  PREQUAL_QUESTION_ERRORED,
  RESET_QUESTIONNAIRE
} from 'actions';
import { LOCATION_CHANGE } from 'react-router-redux';

import { setStateStorageSetting, getStateFromStorage, removeStorageItem } from 'common/storage';

import preQualifyingQuestions from 'common/questionnaires/preQualifyingQuestionnaire/questionDataStore';

import { loadQuestionByIndex, loadNextQuestion, loadAnswer } from 'common/questionnaires/questionnaireHelper';

import { InputType, Preconditions } from 'common/questionnaires/types';

const setPreQualStorageState = () => {
  const location = window.location.pathname;

  if (location.indexOf('pre') > 0 || location.indexOf('selection') > 0) {
    removeStorageItem('formMatched');

    return null;
  }

  return getStateFromStorage('formMatched', null);
};

const findAndUpdateQuestion = (questions, action) => {
  if (!action || !questions || !Array.isArray(questions) || (Array.isArray(questions) && questions.length === 0)) {
    return [];
  }

  return questions.map((q) => {
    if (q.id === action.id) {
      q = {
        ...q,
        isAnswered: action.isAnswered,
        hasError: action.hasError,
        answer: action.answer };
    }
    return q;
  });
};

const checkQuestionsAreValid = (state, mode = 'Irs') => {
  const newState = { ...state,
    formMatched: setStateStorageSetting('formMatched', false),
    derivedName: '',
    questions: [] };

  if (!state || !state.questions) {
    return newState;
  }

  for (let i = 0, q = state.questions[i]; i < state.questions.length; i += 1, q = state.questions[i]) {
    newState.questions.push(q);
    if (!q.isAnswered) return newState;

    const formSuggestion = loadAnswer(q, mode);
    if (formSuggestion != null) {
      newState.formMatched = formSuggestion;
      setStateStorageSetting('formMatched', JSON.stringify(newState.formMatched));
      return newState;
    }

    if (q.inputs && q.inputs.type === InputType.TextFields && q.answer && q.answer !== '') {
      newState.derivedName = q.answer;
    }

    const expectedNextQuestion = loadNextQuestion(preQualifyingQuestions, q, mode);
    if (expectedNextQuestion == null) {
      return newState;
    }

    const existingNextQuestion = state.questions[i + 1];

    if (!existingNextQuestion) {
      newState.questions.push(expectedNextQuestion);
    } else if (expectedNextQuestion.id !== existingNextQuestion.id) {
      newState.questions.push(expectedNextQuestion);
      return newState;
    }
  }

  return newState;
};

const checkPreconditions = (validQuestions, action) => {
  if (action && action.id && validQuestions.questions && Array.isArray(validQuestions.questions)) {
    if (validQuestions.questions.filter(q => q.setsPrecondition && q.answer === 0 && q.setsPrecondition === Preconditions.CustomerRecordNameIsIndividual).length !== 0) {
      validQuestions.customerRecordNameIsIndividual = true;
    }
    if (validQuestions.questions.filter(q => q.setsPrecondition && q.answer === 0 && q.setsPrecondition === Preconditions.LegalOrSoleOwnerIsIndividual).length !== 0) {
      validQuestions.legalOrSoleOwnerIsIndividual = true;
    }
    if (validQuestions.questions.filter(q => q.setsPrecondition && q.answer === 0 && q.setsPrecondition === Preconditions.CustomerRecordNameIsDRE).length !== 0) {
      validQuestions.customerRecordNameIsDRE = true;
    }
  }
};

const questionnaireDefaultStart = {
  formMatched: setPreQualStorageState(),
  derivedName: '',
  customerRecordNameIsIndividual: getStateFromStorage('customerRecordNameIsIndividual', false),
  legalOrSoleOwnerIsIndividual: getStateFromStorage('legalOrSoleOwnerIsIndividual', false),
  customerRecordNameIsDRE: getStateFromStorage('customerRecordNameIsDRE', false),
  questions: [loadQuestionByIndex(preQualifyingQuestions, 0)]
};

function preQualifyingQuestionnaire(state = { ...questionnaireDefaultStart }, action) {
  switch (action.type) {
    case LOCATION_CHANGE:
      return {
        ...state,
        formMatched: setPreQualStorageState()
      };
    case RESET_QUESTIONNAIRE:
      return { ...questionnaireDefaultStart };
    case PREQUAL_QUESTION_ANSWERED:
    case PREQUAL_QUESTION_NOT_ANSWERED:
    case PREQUAL_QUESTION_ERRORED: {
      const validQuestions = checkQuestionsAreValid({
        ...state,
        customerRecordNameIsIndividual: false,
        legalOrSoleOwnerIsIndividual: false,
        customerRecordNameIsDRE: false,
        questions: findAndUpdateQuestion(state.questions, action)
      }, action.mode);

      checkPreconditions(validQuestions, action);

      setStateStorageSetting('customerRecordNameIsIndividual', validQuestions.customerRecordNameIsIndividual);
      setStateStorageSetting('legalOrSoleOwnerIsIndividual', validQuestions.legalOrSoleOwnerIsIndividual);
      setStateStorageSetting('customerRecordNameIsDRE', validQuestions.customerRecordNameIsDRE);

      return validQuestions;
    } default:
      return state;
  }
}

export default preQualifyingQuestionnaire;
